import React, { useContext, useEffect, useState } from "react";
import {
  HTTPResponse,
  SideMenuItems,
  ToastMessages,
  ToastMessageType,
  Values,
} from "../../Helpers/Enums";
import SideBarMenu from "../../Components/SideBarMenu";
import PatientDetails from "../../Components/PatientInformation";
import SaveAndNavigate from "../../Components/SaveAndNavigate";
import DateControl from "../../Components/DateControl";
import {
  CommonError_Msgs,
  EligibilityCriteria_Msgs,
  hyperlinkTextCombinedLKT,
  hyperlinkTextLiver,
  hyperlinkTextS2,
  hyperlinkTextSequentialLKT,
} from "../../Helpers/HelperText";
import ErrorField from "../../Components/ErrorField";
import {
  AddLocalStorageData,
  applySidebarState,
  GetLocalStorageData,
  GetLoggedInUserID,
  IsAdmin,
  RemoveLocalStorageData,
  toggleSidebar,
} from "../../Helpers/Utilities";
import { EligibilityCriteriaService } from "../../WebApiServices/EligibilityCriteria.service";
import { AppContext } from "../../Contexts/AppContextProvider";
import InfoPopUp from "../../Components/InfoPopUp";

const EligibilityCriteria = () => {

  const [patientEligibility, setPatientEligbility] = useState(false);
  const [isAllDataFilled, setIsAllDataFilled] = useState(false);
  const [increment, setIncrement] = useState(1);

  const [isEligibilityLocked, setIsEligibilityLocked] = useState(false);


  let pid = GetLocalStorageData("patientId") ?? 0;
  let patientData = GetLocalStorageData("patient")
  patientData = patientData && JSON.parse(patientData);

  const { ShowToast, ToggleLoader, HandleSessionTimeout, isSideMenuActive, setisSideMenuActive, ShowActionPopUp } =
    useContext(AppContext);
  const surveyDate = patientData?.surveyDate ?? "";
  const [hasConfirmedTermination, setHasConfirmedTermination] = useState(false);


  const [showTopErrMsg, setShowTopErrMsg] = useState(false);
  const [showHideHyperlinkModalS2, setShowHideHyperlinkModalS2] =
    useState(false);

  const [showHideHyperlinkModalCombined, setShowHideHyperlinkModalCombined] =
    useState(false);
  const [
    showHideHyperlinkModalSequential,
    setShowHideHyperlinkModalSequential,
  ] = useState(false);
  const [showHideHyperlinkModalLiver, setShowHideHyperlinkModalLiver] =
    useState(false);
  const indexDateInitial = "index date";
  const [ptDetails, setPtDetails] = useState({
    indexDate: indexDateInitial,
    metInclusionCriteria: null,
    metInclusionCriteria_initial: null,
    eligibilityDisabled: false,
    chart_abs_dt: null,
    //s2
    rbl_conf_diagnosis: null,
    //s3
    rbl_mma_phenotype: null,
    rbl_mma_phenotype_sub: null,
    //s5
    rbl_transplant_type: null,
    rbl_transplant_type_sub: null,
    //s6
    rbl_index: null,
    index_dt: null,
    //s4
    rbl_homocystinuria: null,
    //s7
    rbl_retransplant_liver: null, //old
    rbl_patient_discharged: null,
    //s8
    rbl_retransplant_kidney: null,
    //s9
    rbl_liver_transplant_rejection: null, //old
    rbl_tmt_mma_prior_indexDt: null,
    //s10
    rbl_kidney_transplant_rejection: null,
  });
  const InitialHardErrList = {
    conf_diagnosis_empty: false,
    mma_phenotype_empty: false,
    mma_phenotype_sub_empty: false,
    transplant_type_empty: false,
    transplant_type_sub_empty: false,
    index_empty: false,
    index_dt_empty: false, //not req
    index_dt_invalid: false,
    homocystinuria_empty: false,
    retransplant_liver_empty: false,
    retransplant_kidney_empty: false,
    liver_transplant_rejection_empty: false,
    kidney_transplant_rejection_empty: false,
    patient_discharged_empty: false,
    rbl_tmt_mma_prior_indexDt_empty: false,
  };
  const InitialSoftErrList = {
    conf_diagnosis_term: false,
    mma_phenotype_term: false,
    transplant_type_term: false,
    index_term: false,
    homocystinuria_term: false,
    retransplant_liver_term: false,
    retransplant_kidney_term: false,
    liver_transplant_rejection_term: false,
    kidney_transplant_rejection_term: false,
    rbl_patient_discharged_term: false,
    rbl_tmt_mma_prior_indexDt_term: false,
  };
  const [hardErrList, setHardErrList] = useState(InitialHardErrList);
  const [softErrList, setSoftErrList] = useState(InitialSoftErrList);
  const HandleFieldChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      //S2
      case "rbl_conf_diagnosis":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            ...(valueNum === Values.value0 && {
              rbl_mma_phenotype: null,
              rbl_mma_phenotype_sub: null,
              rbl_transplant_type: null,
              rbl_transplant_type_sub: null,
              rbl_index: null,
              index_dt: null,
              rbl_patient_discharged: null,
              rbl_retransplant_liver: null,
              rbl_homocystinuria: null,
              rbl_tmt_mma_prior_indexDt: null,
            }),
          }));
          setSoftErrList((prev) => ({
            ...prev,
            conf_diagnosis_term: valueNum === 0,
            mma_phenotype_term: false,
            transplant_type_term: false,
            index_term: false,
            rbl_patient_discharged_term: false,
            retransplant_liver_term: false,
            homocystinuria_term: false,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            conf_diagnosis_empty: false,
            mma_phenotype_empty: false,
            mma_phenotype_sub_empty: false,
            transplant_type_empty: false,
            transplant_type_sub_empty: false,
            index_empty: false,
            index_dt_empty: false,
            index_dt_invalid: false,
            patient_discharged_empty: false,
            retransplant_liver_empty: false,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));

        }
        break;
      //S3
      case "rbl_mma_phenotype":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            rbl_mma_phenotype_sub: null,

            ...(valueNum === Values.value2 || valueNum === Values.value3) && {
              rbl_transplant_type: null,
              rbl_transplant_type_sub: null,
              rbl_index: null,
              index_dt: null,
              rbl_patient_discharged: null,
              rbl_retransplant_liver: null,
              rbl_homocystinuria: null,
              rbl_tmt_mma_prior_indexDt: null,
            },

          }));
          setSoftErrList((prev) => ({
            ...prev,
            mma_phenotype_term: valueNum === Values.value2 || valueNum === Values.value3,
            transplant_type_term: false,
            index_term: false,
            rbl_patient_discharged_term: false,
            retransplant_liver_term: false,
            homocystinuria_term: false,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            mma_phenotype_empty: false,
            mma_phenotype_sub_empty: false,
            transplant_type_empty: false,
            transplant_type_sub_empty: false,
            index_empty: false,
            index_dt_empty: false,
            index_dt_invalid: false,
            patient_discharged_empty: false,
            retransplant_liver_empty: false,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));


        }
        break;



      //S3 sub
      case "rbl_mma_phenotype_sub":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            rbl_mma_phenotype: 1,
          }));

          setSoftErrList((prev) => ({
            ...prev,
            mma_phenotype_term: false,
            // transplant_type_term: false,
            index_term: valueNum !== Values.value1 && valueNum !== Values.value2 ? false : prev.index_term,
            rbl_patient_discharged_term: false,
            retransplant_liver_term: false,
            homocystinuria_term: false,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));

          setHardErrList((prev) => ({
            ...prev,
            mma_phenotype_sub_empty: false,
            mma_phenotype_empty: false,
            transplant_type_empty: false,
            transplant_type_sub_empty: false,
            index_empty: false,
            index_dt_empty: false,
            index_dt_invalid: false,
            patient_discharged_empty: false,
            retransplant_liver_empty: false,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));

        }
        break;
      //S4
      case "rbl_transplant_type":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            rbl_transplant_type_sub: null,
            ...(valueNum === Values.value3 || (valueNum === Values.value2 && prev.rbl_transplant_type_sub === null)) && {
              rbl_index: null,
              index_dt: null,
              rbl_patient_discharged: null,
              rbl_retransplant_liver: null,
              rbl_homocystinuria: null,
              rbl_tmt_mma_prior_indexDt: null,
            },

          }));
          setSoftErrList((prev) => ({
            ...prev,
            transplant_type_term: valueNum === Values.value3,
            index_term: valueNum !== Values.value1 ? false : prev.index_term, // Only update if condition is met
            rbl_patient_discharged_term: false,
            retransplant_liver_term: false,
            homocystinuria_term: false,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            transplant_type_empty: false,
            transplant_type_sub_empty: false,
            index_empty: false,
            index_dt_empty: false,
            index_dt_invalid: false,
            patient_discharged_empty: false,
            retransplant_liver_empty: false,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));

        }
        break;

      //S4 sub
      case "rbl_transplant_type_sub":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            rbl_transplant_type: Values.value2,
          }));
          setSoftErrList((prev) => ({
            ...prev,
            transplant_type_term: false,
            // index_term: false,
            rbl_patient_discharged_term: false,
            retransplant_liver_term: false,
            homocystinuria_term: false,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            transplant_type_sub_empty: false,
            transplant_type_empty: false,
            index_empty: false,
            index_dt_empty: false,
            index_dt_invalid: false,
            patient_discharged_empty: false,
            retransplant_liver_empty: false,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));
        }
        break;

      //S5
      case "rbl_index":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            index_dt: null,
            indexDate: indexDateInitial,

            ...(valueNum === Values.value99 && {
              rbl_patient_discharged: null,
              rbl_retransplant_liver: null,
              rbl_homocystinuria: null,
              rbl_tmt_mma_prior_indexDt: null,
            })

          }));
          setSoftErrList((prev) => ({
            ...prev,
            index_term: valueNum === Values.value99,
            rbl_patient_discharged_term: false,
            retransplant_liver_term: false,
            homocystinuria_term: false,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            index_empty: false,
            patient_discharged_empty: false,
            retransplant_liver_empty: false,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));
        }
        break;

      //S8.
      case "rbl_homocystinuria":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            rbl_tmt_mma_prior_indexDt: Number(valueNum) === Values.value1 ? null : prev.rbl_tmt_mma_prior_indexDt
          }));
          setSoftErrList((prev) => ({
            ...prev,
            homocystinuria_term: valueNum === 1,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));

        }
        break;

      //S7
      case "rbl_retransplant_liver":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
            rbl_homocystinuria: valueNum === Values.value1 ? null : prev.rbl_homocystinuria,
            rbl_tmt_mma_prior_indexDt: valueNum === Values.value1 ? null : prev.rbl_tmt_mma_prior_indexDt

          }));
          setSoftErrList((prev) => ({
            ...prev,
            retransplant_liver_term: valueNum === 1,
            homocystinuria_term: false
          }));
          setHardErrList((prev) => ({
            ...prev,
            retransplant_liver_empty: false,
          }));

        }
        break;

      case "rbl_retransplant_kidney":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
          }));
          setSoftErrList((prev) => ({
            ...prev,
            retransplant_kidney_term: valueNum === 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            retransplant_kidney_empty: false,
          }));
        }
        break;

      case "rbl_liver_transplant_rejection":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
          }));
          setSoftErrList((prev) => ({
            ...prev,
            liver_transplant_rejection_term: valueNum === 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            liver_transplant_rejection_empty: false,
          }));
        }
        break;
      case "rbl_kidney_transplant_rejection":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
          }));
          setSoftErrList((prev) => ({
            ...prev,
            kidney_transplant_rejection_term: valueNum === 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            kidney_transplant_rejection_empty: false,
          }));
        }
        break;

      //S6.
      case "rbl_patient_discharged":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,

            rbl_retransplant_liver: valueNum === Values.value0 ? null : prev.rbl_retransplant_liver,
            rbl_homocystinuria: valueNum === Values.value0 ? null : prev.rbl_homocystinuria,
            rbl_tmt_mma_prior_indexDt: valueNum === Values.value0 ? null : prev.rbl_tmt_mma_prior_indexDt,
          }));
          setSoftErrList((prev) => ({
            ...prev,
            rbl_patient_discharged_term: valueNum === 0,
            retransplant_liver_term: false,
            homocystinuria_term: false,
            rbl_tmt_mma_prior_indexDt_term: false,
          }));
          setHardErrList((prev) => ({
            ...prev,
            patient_discharged_empty: false,
            retransplant_liver_empty: false,
            homocystinuria_empty: false,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));

        }
        break;

      //S9.
      case "rbl_tmt_mma_prior_indexDt":
        {
          const valueNum = Number(value);
          setPtDetails((prev) => ({
            ...prev,
            [name]: valueNum,
          }));
          setSoftErrList((prev) => ({
            ...prev,
            rbl_tmt_mma_prior_indexDt_term: valueNum === 1,
          }));
          setHardErrList((prev) => ({
            ...prev,
            rbl_tmt_mma_prior_indexDt_empty: false,
          }));
        }
        break;

      default:
        break;
    }
  };



  const HandleDateChange = (name, date) => {
      setPtDetails((prev) => ({
        ...prev,
        [name]: date,
        rbl_index: 1,
        rbl_patient_discharged: Number(prev.rbl_index) === Values.value99 ? null : prev.rbl_patient_discharged,
      }));
  
      setHardErrList((prev) => ({
        ...prev,
        index_empty: false,
        index_dt_empty: false,
        index_dt_invalid: false,
      }));
  
      setSoftErrList((prev) => ({
        ...prev,
        index_term: false,
      }));
  };

  



  useEffect(() => {
    async function FetchData() {
      if (!isNaN(pid) && Number(pid) !== 0) {
        ToggleLoader(true);
        await LoadData();
        ToggleLoader(false);
      }
    }
    FetchData();
  }, []);
  const SavePage = async () => {
    try {      
      if (!isEligibilityLocked) {
        //Reset Errors
        setHardErrList(InitialHardErrList);
        setSoftErrList(InitialSoftErrList);

        if (!Validate()) {
          setShowTopErrMsg(true);
          ToggleLoader(false);
          return false;
        }
        setShowTopErrMsg(false);
        const payload = {
          PatientId: pid,
          AbstractorId: GetLoggedInUserID(),
          MetInclusionCriteria: ValidateEligibility(),
          IsAdmin: IsAdmin(),
          MmaDiagnosis: ptDetails.rbl_conf_diagnosis, //s1
          MmaType: ptDetails.rbl_mma_phenotype, //s2 type
          MmaPhenoType: ptDetails.rbl_mma_phenotype_sub, //phenotype -s2 sub options
          HomocystinuriaDiagnosis: ptDetails.rbl_homocystinuria, // s4
          LiverTransplant: ptDetails.rbl_transplant_type, // s5
          LiverTransplantLkt: ptDetails.rbl_transplant_type_sub, //s5 - sub options
          IndexdateProcedure: ptDetails.index_dt, //s6
          IndexdateProcedureUnknown: ptDetails.rbl_index === Values.value99, //s6 unknown

          HospitalizationDischarge: ptDetails.rbl_patient_discharged, //s7
          LiverRetransplantation: ptDetails.rbl_retransplant_liver, // s8
          MmaPriorIndexdate: ptDetails.rbl_tmt_mma_prior_indexDt, //s9
        };
        ToggleLoader(true);
        const response = await EligibilityCriteriaService.SaveEligibilityCriteria(payload);
        ToggleLoader(false);
        if (response.status !== HTTPResponse.OK) {
          if (response?.status === HTTPResponse.Unauthorized) {
            HandleSessionTimeout();
          } else throw response.error;
        } else {

          setIncrement(increment => increment + 1);
          ShowToast(ToastMessages.Save_Success, ToastMessageType.Success);
          await LoadData();
          if (response) {
            const { data } = response;
            if (data) {
              //newly created patient
              if (data.patientId != 0) {
                if (data.metInclusionCriteria) {
                  navigatePaths.nextPage = "/Demographics";
                } else if (data.metInclusionCriteria === false) {

                  //previously eligible
                  if (ptDetails.metInclusionCriteria_initial === false) {
                 if (patientEligibility && isAllDataFilled) {
                    navigatePaths.nextPage = "/Demographics";
                  } else if (patientEligibility === false && increment === 2) {
                    navigatePaths.nextPage = "/ManagePatients";
                  } else {
                    navigatePaths.nextPage = "/EligibilityCriteria";
                  }
                    RemoveLocalStorageData("patient");
                    RemoveLocalStorageData("patientId");
                  }
                }
              }
              SetFields(data);
            }
          }
          if (response?.data?.showIndexDateChangeAlert) {
            ShowAlertBox();
          }
        }
        if (response.data.metInclusionCriteria === false) {
          // Patient is terminated
          if (!hasConfirmedTermination) {
            // On first validate/next click: show the ineligible message at the top
            setHasConfirmedTermination(true);
            ToggleLoader(false);
            return false; // Stay on the same page
          } else {
            // On second validate/next click: redirect to ManagePatients
            //navigatePaths.nextPage = "/ManagePatients";
           // navigatePaths.nextPage = patientEligibility && isAllDataFilled ? "/Demographics" : (patientEligibility === false && increment === 2) ? "/ManagePatients" : "/EligibilityCriteria"
          
           if (patientEligibility && isAllDataFilled) {
            navigatePaths.nextPage = "/Demographics";
          } else if (patientEligibility === false && increment === 2) {
            navigatePaths.nextPage = "/ManagePatients";
          } else {
            navigatePaths.nextPage = "/EligibilityCriteria";
          }

          }
        } else {
          // Patient is eligible, navigate to the demographics page (or your designated page)
          navigatePaths.nextPage = "/Demographics";
        }
      }
      return true;
    } catch (error) {
      ShowToast(CommonError_Msgs.SAVE_ERR, ToastMessageType.Failed);
    }
  };
  async function LoadData() {
    try {
      const response = await EligibilityCriteriaService.LoadEligibilityCriteria(pid);
      if (response?.status === HTTPResponse.OK) {
        const { data } = response;
        setHasConfirmedTermination(!data.metInclusionCriteria);
        setPatientEligbility(data.metInclusionCriteria);
        SetFields(data);
      } else {
        if (response?.status === HTTPResponse.Unauthorized) {
          HandleSessionTimeout();
        } else {
          throw response.error;
        }
      }
    } catch (error) {
      ShowToast(CommonError_Msgs.LOAD_ERR, ToastMessageType.Failed);
    }
  }

  const ValidateEligibility = () => {
    let isEligible = true;
    if (
      ptDetails.rbl_conf_diagnosis === Values.value0 ||
      ptDetails.rbl_mma_phenotype === Values.value2 ||
      ptDetails.rbl_mma_phenotype === Values.value3 ||
      ptDetails.rbl_transplant_type === Values.value3 ||
      ptDetails.rbl_index === Values.value99 ||
      ptDetails.rbl_homocystinuria === Values.value1 ||
      ptDetails.rbl_retransplant_liver === Values.value1 ||
      ptDetails.rbl_patient_discharged === Values.value0 ||
      ptDetails.rbl_tmt_mma_prior_indexDt === Values.value1
    ) {
      isEligible = false;
    }
    setPatientEligbility(isEligible);
    return isEligible;
  };

  const SetFields = (data) => {
    pid = data.patientId;
    setIsEligibilityLocked(data.eligibilityLocked);
    AddLocalStorageData("EligibiltLocked", data.eligibilityLocked);
  
  
    const indexDate = data.indexdateProcedure || indexDateInitial;



       AddLocalStorageData("SaveEligibilityIndexDate",indexDate);
  
    let rbl_conf_diagnosis = null;
    if (data.mmaDiagnosis === true) rbl_conf_diagnosis = 1;
    else if (data.mmaDiagnosis === false) rbl_conf_diagnosis = 0;
  
    let rbl_homocystinuria = null;
    if (data.homocystinuriaDiagnosis === true) rbl_homocystinuria = 1;
    else if (data.homocystinuriaDiagnosis === false) rbl_homocystinuria = 0;
  
    let rbl_index = null;
    if (data.indexdateProcedureUnknown) rbl_index = Values.value99;
    else if (data.indexdateProcedure) rbl_index = 1;
  
    let rbl_patient_discharged = null;
    if (data.hospitalizationDischarge === true) rbl_patient_discharged = 1;
    else if (data.hospitalizationDischarge === false) rbl_patient_discharged = 0;
  
    let rbl_retransplant_liver = null;
    if (data.liverRetransplantation === true) rbl_retransplant_liver = 1;
    else if (data.liverRetransplantation === false) rbl_retransplant_liver = 0;
  
    let rbl_tmt_mma_prior_indexDt = null;
    if (data.mmaPriorIndexdate === true) rbl_tmt_mma_prior_indexDt = 1;
    else if (data.mmaPriorIndexdate === false) rbl_tmt_mma_prior_indexDt = 0;
  
    setPtDetails((prev) => ({
      ...prev,
      indexDate,
      chart_abs_dt: data.chartAbstractionDate,
      metInclusionCriteria: data.metInclusionCriteria,
      metInclusionCriteria_initial: data.metInclusionCriteria,
  
      rbl_conf_diagnosis,
      rbl_mma_phenotype: data.mmaType,
      rbl_mma_phenotype_sub: data.mmaPhenoType,
      rbl_homocystinuria,
      rbl_transplant_type: data.liverTransplant,
      rbl_transplant_type_sub: data.liverTransplantLkt,
      index_dt: data.indexdateProcedure,
      rbl_index,
      rbl_patient_discharged,
      rbl_retransplant_liver,
      rbl_tmt_mma_prior_indexDt,
      eligibilityDisabled: data.eligibilityLocked,
    }));
  };
  

  const Validate = () => {

    let isValid = true;
    if (ptDetails.rbl_conf_diagnosis == null) {
      setHardErrList((prev) => ({
        ...prev,
        conf_diagnosis_empty: true,
      }));
      isValid = false;
    }
    //s2
    if (ptDetails.rbl_conf_diagnosis === Values.value0) {
      return isValid;
    }
    if (ptDetails.rbl_mma_phenotype === null) {
      setHardErrList((prev) => ({
        ...prev,
        mma_phenotype_empty: true,
      }));
      isValid = false;
    }

    if (
      Number(ptDetails.rbl_mma_phenotype) === Values.value1 &&
      ptDetails.rbl_mma_phenotype_sub === null
    ) {
      setHardErrList((prev) => ({
        ...prev,
        mma_phenotype_sub_empty: true,
      }));
      isValid = false;
    }
    //s3
    if (ptDetails.rbl_mma_phenotype === Values.value2 || ptDetails.rbl_mma_phenotype === Values.value3) {
      return isValid;
    }
    if (ptDetails.rbl_transplant_type === null) {
      setHardErrList((prev) => ({
        ...prev,
        transplant_type_empty: true,
      }));
      isValid = false;
    }
    if (
      Number(ptDetails.rbl_transplant_type) === Values.value2 &&
      ptDetails.rbl_transplant_type_sub === null
    ) {
      setHardErrList((prev) => ({
        ...prev,
        transplant_type_sub_empty: true,
      }));
      isValid = false;
    }
    //s4
    if (ptDetails.rbl_transplant_type === Values.value3) {
      return isValid;
    }

    if (ptDetails.rbl_index === null) {
      setHardErrList((prev) => ({
        ...prev,
        index_empty: true,
      }));
      isValid = false;
    } else {
      if (ptDetails.rbl_index === 1) {
        if (ptDetails.index_dt === null) {
          setHardErrList((prev) => ({
            ...prev,
            index_dt_empty: true,
          }));
          isValid = false;
        }

   
      }
    }
    //s5
    if (ptDetails.rbl_index === Values.value99) {
      return isValid;
    }
    if (ptDetails.rbl_index === Values.value1 && ptDetails.index_dt != null && ptDetails.rbl_patient_discharged === null) {
      setHardErrList((prev) => ({
        ...prev,
        patient_discharged_empty: true,
      }));
      isValid = false;
    }
    //s6
    if (ptDetails.rbl_patient_discharged === Values.value0) {
      return isValid;
    }
    if (ptDetails.rbl_retransplant_liver === null) {
      setHardErrList((prev) => ({
        ...prev,
        retransplant_liver_empty: true,
      }));
      isValid = false;
    }
    //s7
    if (ptDetails.rbl_retransplant_liver === Values.value1) {
      return isValid;
    }
    if (ptDetails.rbl_retransplant_liver === Values.value0 && ptDetails.rbl_homocystinuria == null) {
      setHardErrList((prev) => ({
        ...prev,
        homocystinuria_empty: true,
      }));
      isValid = false;
    }
    //s8
    if (ptDetails.rbl_homocystinuria === Values.value1) {
      return isValid;
    }

    if (ptDetails.rbl_tmt_mma_prior_indexDt === null) {
      setHardErrList((prev) => ({
        ...prev,
        rbl_tmt_mma_prior_indexDt_empty: true,
      }));
      isValid = false;
    }
    //s9
    if (ptDetails.rbl_homocystinuria === Values.value1) {
      return isValid;
    }
    setIsAllDataFilled(isValid);
    return isValid;
  };


  useEffect(() => {
    applySidebarState(isSideMenuActive);
  }, [isSideMenuActive]);


  //SYJ Changes-> to show alert message when Index date is Updated once patient is unlocked.
  const ShowAlertBox = async () => {
    await ShowActionPopUp(
      "Alert", //title
      CommonError_Msgs.DateChangeAlert, //message
      "Ok", //Confirm button text
      true
    );
  };



  let nextPagePath = "/EligibilityCriteria";

  if (isEligibilityLocked) {
    nextPagePath = patientEligibility ? "/Demographics" : "/ManagePatients";
  } else {
    if (patientEligibility && isAllDataFilled) {
      nextPagePath = "/Demographics";
    } else if (patientEligibility === false && increment === 2) {
      nextPagePath = "/ManagePatients";
    }
  }
  
  const navigatePaths = {
    prevPage: "/PatientScreening",
    currPage: "/EligibilityCriteria",
    nextPage: nextPagePath,
  };

  return (
    <>
      <section className="survey-patient-details-section">
        <div className="row">
          <PatientDetails />
          <div className="col-12 col-sm-5 col-md-5 col-lg-6 col-content-alignment">
            <SaveAndNavigate paths={navigatePaths} Save={SavePage} eligible={ptDetails.metInclusionCriteria} />
          </div>
        </div>
      </section>

      <section className="main-survey-section main-survey-button">
        <div >
          <SideBarMenu activePageId={SideMenuItems.EligibilityCriteria} />
          <>
            <button className={isSideMenuActive ? "openbtn" : "openbtn active"}
              onClick={() => toggleSidebar(isSideMenuActive, setisSideMenuActive)}
            >
              <i
                id="arrowNavigation"
                className="fa fa-arrow-left"
                aria-hidden="true"
              ></i>
            </button>
          </>
          <div className="col-pad-left eligibiltylocked" id="main">
            <div className="survey-section-content survey-content-box" id="contentsec">
              <div className="survey-section-content-header">
                <h4>ELIGIBILITY CRITERIA</h4>
              </div>
              {showTopErrMsg && (
                <div className="clean-error">
                  <ErrorField
                    show={showTopErrMsg}
                    message={CommonError_Msgs.Hard_Empty}
                  />
                </div>
              )}
              
              {!showTopErrMsg &&
                (ptDetails.metInclusionCriteria ? (
                  <div
                    className="clean-ok"
                    dangerouslySetInnerHTML={{
                      __html: EligibilityCriteria_Msgs.Eligible,
                    }}
                  />
                ) : (
                  hasConfirmedTermination &&
                  pid !== 0 &&
                  ptDetails.metInclusionCriteria !== null &&
                  ptDetails.metInclusionCriteria === false && (
                    <div className="clean-error">
                      <p>{EligibilityCriteria_Msgs.Ineligible}</p>
                    </div>
                  )
                ))}


              <div className="survey-question-section" disabled={ptDetails.eligibilityDisabled}>
                <div className="survey-question-content survey-content-box-eligibility">
                  <div className="question-answer">
                    <table
                      cellPadding="0"
                      cellSpacing="0"
                      border="0"
                      width="100%"
                    >
                      <tr>
                        <td className="">
                          {/* mainContent */}
                          <table
                            cellPadding="0"
                            cellSpacing="0"
                            width="100%"
                            border="1"
                            className="borderTable"
                          >
                            <tr>
                              <td className="containertd">
                                <div className="question question-weight">
                                  <span>S1.</span>
                                  <span className="quest-text-pad">
                                    Date of starting chart abstraction
                                  </span>
                                </div>
                              </td>
                              <td className="containertd question-weight">
                                {surveyDate}
                              </td>
                            </tr>
                            <tr>
                              <td className="containertd">
                                <div className="question question-weight">
                                  <span>S2.</span>
                                  <span className="quest-text-pad">
                                    <span
                                      data-tooltip-id="encounterTip"
                                      className="modal-popup"
                                      onClick={() =>
                                        setShowHideHyperlinkModalS2(true)
                                      }
                                    >
                                      Confirmed diagnosis
                                    </span>
                                    {showHideHyperlinkModalS2 && (
                                      <InfoPopUp
                                        description={hyperlinkTextS2}
                                        OkClick={() =>
                                          setShowHideHyperlinkModalS2(false)
                                        }
                                      />
                                    )}{" "}
                                    of MMA
                                  </span>
                                </div>
                              </td>
                              <td className="containertd">
                                <div className="">
                                  <div>
                                    <label>
                                      <input
                                        type="radio"
                                        id="conf_diagnosis_y"
                                        name="rbl_conf_diagnosis"
                                        value={1}
                                        checked={
                                          ptDetails.rbl_conf_diagnosis === Values.value1
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        Yes
                                      </span>
                                    </label>
                                  </div>
                                  <div>
                                    <label>
                                      <input
                                        type="radio"
                                        id="conf_diagnosis_y"
                                        name="rbl_conf_diagnosis"
                                        value={0}
                                        checked={
                                          ptDetails.rbl_conf_diagnosis === Values.value0
                                        }
                                        onChange={HandleFieldChange}
                                      />
                                      <span className="radio-text-padding">
                                        No
                                      </span>
                                    </label>
                                  </div>
                                </div>
                                <ErrorField
                                  show={hardErrList.conf_diagnosis_empty}
                                  message={CommonError_Msgs.Msg1}
                                />
                                <ErrorField
                                  show={softErrList.conf_diagnosis_term}
                                  message={EligibilityCriteria_Msgs.Ineligible}
                                />
                              </td>
                            </tr>
                            {ptDetails.rbl_conf_diagnosis === Values.value1 && (
                              <tr>
                                <td className="containertd">
                                  <div className="question question-weight">
                                    <span>S3.</span>
                                    <span className="quest-text-pad">
                                      MMA type
                                    </span>
                                  </div>
                                </td>
                                <td className="containertd">
                                  <div className="">
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="mma_phenotype_1"
                                          name="rbl_mma_phenotype"
                                          value={1}
                                          checked={
                                            ptDetails.rbl_mma_phenotype ===
                                            Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          <i>Mut</i>
                                        </span>
                                      </label>
                                    </div>

                                    <div className="radio-text-padding margin-align">
                                      <label>
                                        <input
                                          type="radio"
                                          id="mma_phenotype_sub_1"
                                          name="rbl_mma_phenotype_sub"
                                          value={1}
                                          checked={
                                            ptDetails.rbl_mma_phenotype_sub ===
                                            Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          <i>
                                            Mut<sup>0</sup>
                                          </i>{" "}
                                          phenotype
                                        </span>
                                      </label>
                                    </div>
                                    <div className="radio-text-padding margin-align">
                                      <label>
                                        <input
                                          type="radio"
                                          id="mma_phenotype_sub_2"
                                          name="rbl_mma_phenotype_sub"
                                          value={2}
                                          checked={
                                            ptDetails.rbl_mma_phenotype_sub ===
                                            Values.value2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          <i>
                                            Mut<sup>–</sup>
                                          </i>{" "}
                                          phenotype
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label className="long-text-option">
                                        <input
                                          type="radio"
                                          id="mma_phenotype_2"
                                          name="rbl_mma_phenotype"
                                          value={2}
                                          checked={
                                            ptDetails.rbl_mma_phenotype ===
                                            Values.value2
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Cobalamin-related subtype (e.g., cblA,
                                          cblB, cblD){" "}
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="mma_phenotype_3"
                                          name="rbl_mma_phenotype"
                                          value={3}
                                          checked={
                                            ptDetails.rbl_mma_phenotype ===
                                            Values.value3
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Methylmalonyl-CoA epimerase{" "}
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={hardErrList.mma_phenotype_empty}
                                    message={CommonError_Msgs.Msg1}
                                  />
                                  <ErrorField
                                    show={hardErrList.mma_phenotype_sub_empty}
                                    message={CommonError_Msgs.Msg1}
                                  />
                                  <ErrorField
                                    show={softErrList.mma_phenotype_term}
                                    message={EligibilityCriteria_Msgs.Ineligible}
                                  />
                                </td>
                              </tr>
                            )}

                            {(ptDetails.rbl_mma_phenotype == Values.value1 &&
                              (ptDetails.rbl_mma_phenotype_sub === Values.value1 ||
                                ptDetails.rbl_mma_phenotype_sub === Values.value2))
                              && (
                                <tr>
                                  <td className="containertd">
                                    <div className="question question-weight">
                                      <span>S4.</span>
                                      <span className="quest-text-pad">
                                        Did the patient undergo liver transplant
                                        (LT), either as a single procedure or as
                                        part of a liver-kidney transplant (LKT)?
                                      </span>
                                    </div>
                                  </td>
                                  <td className="containertd">
                                    <div className="">
                                      <div>
                                        <label>
                                          <input
                                            type="radio"
                                            id="transplant_type_1"
                                            name="rbl_transplant_type"
                                            value={1}
                                            checked={
                                              ptDetails.rbl_transplant_type === Values.value1
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Yes, the patient underwent LT
                                          </span>
                                        </label>
                                      </div>

                                      <div>
                                        <label>
                                          <input
                                            type="radio"
                                            id="transplant_type_2"
                                            name="rbl_transplant_type"
                                            value={2}
                                            checked={
                                              ptDetails.rbl_transplant_type ===
                                              Values.value2
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Yes, the patient underwent LKT
                                          </span>
                                        </label>
                                      </div>

                                      <div className="radio-text-padding margin-align">
                                        <label>
                                          <input
                                            type="radio"
                                            id="rbl_transplant_type_sub_1"
                                            name="rbl_transplant_type_sub"
                                            value={1}
                                            checked={
                                              ptDetails.rbl_transplant_type_sub ===
                                              Values.value1
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span
                                            data-tooltip-id="encounterTip"
                                            className="modal-popup radio-text-padding"
                                            onClick={() =>
                                              setShowHideHyperlinkModalCombined(
                                                true
                                              )
                                            }
                                          >
                                            Combined LKT
                                          </span>
                                          {showHideHyperlinkModalCombined && (
                                            <InfoPopUp
                                              description={hyperlinkTextCombinedLKT}
                                              OkClick={() =>
                                                setShowHideHyperlinkModalCombined(
                                                  false
                                                )
                                              }
                                            />
                                          )}{" "}
                                        </label>
                                      </div>
                                      <div className="radio-text-padding margin-align">
                                        <label>
                                          <input
                                            type="radio"
                                            id="rbl_transplant_type_sub_2"
                                            name="rbl_transplant_type_sub"
                                            value={2}
                                            checked={
                                              ptDetails.rbl_transplant_type_sub ===
                                              Values.value2
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span
                                            data-tooltip-id="encounterTip"
                                            className="modal-popup radio-text-padding"
                                            onClick={() =>
                                              setShowHideHyperlinkModalSequential(
                                                true
                                              )
                                            }
                                          >
                                            Sequential LKT
                                          </span>
                                          {showHideHyperlinkModalSequential && (
                                            <InfoPopUp
                                              description={
                                                hyperlinkTextSequentialLKT
                                              }
                                              OkClick={() =>
                                                setShowHideHyperlinkModalSequential(
                                                  false
                                                )
                                              }
                                            />
                                          )}{" "}
                                        </label>
                                      </div>

                                      <div>
                                        <label>
                                          <input
                                            type="radio"
                                            id="transplant_type_3"
                                            name="rbl_transplant_type"
                                            value={3}
                                            checked={
                                              ptDetails.rbl_transplant_type ===
                                              Values.value3
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            No, the patient did not undergo LT or
                                            LKT{" "}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorField
                                      show={hardErrList.transplant_type_empty}
                                      message={CommonError_Msgs.Msg1}
                                    />
                                    <ErrorField
                                      show={hardErrList.transplant_type_sub_empty}
                                      message={CommonError_Msgs.Msg1}
                                    />
                                    <ErrorField
                                      show={softErrList.transplant_type_term}
                                      message={EligibilityCriteria_Msgs.Ineligible}
                                    />
                                  </td>
                                </tr>
                              )}

                            {((ptDetails.rbl_transplant_type === Values.value1)
                              || (ptDetails.rbl_transplant_type === Values.value2 && (ptDetails.rbl_transplant_type_sub === Values.value1 || ptDetails.rbl_transplant_type_sub === Values.value2)))
                              && (
                                <tr>
                                  <td className="containertd">
                                    <div className="question question-weight">
                                      <span>S5.</span>
                                      <span className="quest-text-pad">
                                        Date of LT procedure, either as LT or LKT
                                        <br />
                                        <br />
                                        <b>Please Note:</b> This will be defined as
                                        the{" "}
                                        <u>
                                          <i>index date</i>
                                        </u>{" "}
                                        for the patient. The index date should be
                                        the date of LT even if the patient underwent
                                        a {""}
                                        <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup "
                                          onClick={() =>
                                            setShowHideHyperlinkModalCombined(true)
                                          }
                                        >
                                          Combined LKT {""}
                                        </span>
                                        <span>or a {""}</span>
                                        <span
                                          data-tooltip-id="encounterTip"
                                          className="modal-popup "
                                          onClick={() =>
                                            setShowHideHyperlinkModalSequential(
                                              true
                                            )
                                          }
                                        >
                                          {""}
                                          Sequential LKT
                                        </span>
                                      </span>
                                    </div>
                                  </td>
                                  <td className="containertd">
                                    <div className="">
                                      <div>
                                        <input
                                          type="radio"
                                          id="index_1"
                                          name="rbl_index"
                                          value={1}
                                          checked={ptDetails.rbl_index === Values.value1}
                                          onChange={HandleFieldChange}
                                        />
                                        <span style={{ marginLeft: "15px" }}>
                                          <DateControl
                                            ctrlId={"index_dt"}
                                            HandleDateChange={HandleDateChange}
                                            date={ptDetails.index_dt}
                                          />
                                        </span>
                                      </div>
                                      <div>
                                        <label>
                                          <input
                                            type="radio"
                                            id="index_99"
                                            name="rbl_index"
                                            value={99}
                                            checked={
                                              ptDetails.rbl_index === Values.value99
                                            }
                                            onChange={HandleFieldChange}
                                          />
                                          <span className="radio-text-padding">
                                            Date Unknown
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                    <ErrorField
                                      show={softErrList.index_term}
                                      message={EligibilityCriteria_Msgs.Ineligible}
                                    />
                                    <ErrorField
                                      show={hardErrList.index_empty}
                                      message={CommonError_Msgs.Msg1}
                                    />
                                    <ErrorField
                                      show={hardErrList.index_dt_empty}
                                      message={CommonError_Msgs.Msg2}
                                    />
                                    <ErrorField
                                      show={hardErrList.index_dt_invalid}
                                      message={CommonError_Msgs.Msg2}
                                    />
                                  </td>
                                </tr>
                              )}

                            {(ptDetails.rbl_index === Values.value1 && ptDetails.index_dt != null) && (
                              <tr>
                                <td className="containertd">
                                  <div className="question question-weight">
                                    <span>S6.</span>
                                    <span className="quest-text-pad">
                                      Was the patient successfully discharged from
                                      the hospitalization where they received
                                      LT/LKT?
                                    </span>
                                  </div>
                                </td>
                                <td className="containertd">
                                  <div className="">
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="patient_discharged_1"
                                          name="rbl_patient_discharged"
                                          value={1}
                                          checked={
                                            ptDetails.rbl_patient_discharged === 1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Yes
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="rbl_patient_discharged_0"
                                          name="rbl_patient_discharged"
                                          value={0}
                                          checked={
                                            ptDetails.rbl_patient_discharged === 0
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          No
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={softErrList.rbl_patient_discharged_term}
                                    message={EligibilityCriteria_Msgs.Ineligible}
                                  />
                                  <ErrorField
                                    show={hardErrList.patient_discharged_empty}
                                    message={CommonError_Msgs.Msg1}
                                  />
                                </td>
                              </tr>
                            )}

                            {ptDetails.rbl_patient_discharged === Values.value1 && (
                              <tr>
                                <td className="containertd">
                                  <div className="question question-weight">
                                    <span>S7.</span>
                                    <span className="quest-text-pad">
                                      Has the patient undergone {""}
                                      <span
                                        data-tooltip-id="encounterTip"
                                        className="modal-popup "
                                        onClick={() =>
                                          setShowHideHyperlinkModalLiver(true)
                                        }
                                      >
                                        liver re-transplantation
                                      </span>
                                      {showHideHyperlinkModalLiver && (
                                        <InfoPopUp
                                          description={hyperlinkTextLiver}
                                          OkClick={() =>
                                            setShowHideHyperlinkModalLiver(false)
                                          }
                                        />
                                      )}{" "}
                                      since the index date (
                                      <span className="indigo-text">
                                        {ptDetails.index_dt || "index date"}
                                      </span>
                                      )?
                                      <br />
                                      <br />
                                    </span>
                                  </div>
                                </td>
                                <td className="containertd">
                                  <div className="">
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="retransplant_liver_1"
                                          name="rbl_retransplant_liver"
                                          value={1}
                                          checked={
                                            ptDetails.rbl_retransplant_liver === Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Yes
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="retransplant_liver_0"
                                          name="rbl_retransplant_liver"
                                          value={0}
                                          checked={
                                            ptDetails.rbl_retransplant_liver === 0
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          No
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={softErrList.retransplant_liver_term}
                                    message={EligibilityCriteria_Msgs.Ineligible}
                                  />
                                  <ErrorField
                                    show={hardErrList.retransplant_liver_empty}
                                    message={CommonError_Msgs.Msg1}
                                  />
                                </td>
                              </tr>
                            )}
                            
                           
                           
                            {ptDetails.rbl_retransplant_liver === Values.value0 && (
                              <tr>
                                <td className="containertd">
                                  <div className="question question-weight">
                                    <span>S8.</span>
                                    <span className="quest-text-pad">
                                      Did the patient have a diagnosis of
                                      homocystinuria prior to the index date (
                                      <span className="indigo-text">
                                        {ptDetails.index_dt || "index date"}
                                      </span>
                                      )?
                                    </span>
                                  </div>
                                </td>
                                <td className="containertd">
                                  <div className="">
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="homocystinuria_1"
                                          name="rbl_homocystinuria"
                                          value={1}
                                          checked={
                                            ptDetails.rbl_homocystinuria === Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Yes
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="homocystinuria_0"
                                          name="rbl_homocystinuria"
                                          value={0}
                                          checked={
                                            ptDetails.rbl_homocystinuria === 0
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          No
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={softErrList.homocystinuria_term}
                                    message={EligibilityCriteria_Msgs.Ineligible}
                                  />
                                  <ErrorField
                                    show={hardErrList.homocystinuria_empty}
                                    message={CommonError_Msgs.Msg1}
                                  />
                                </td>
                              </tr>
                            )}

                            {ptDetails.rbl_homocystinuria === Values.value0 && (
                              <tr>
                                <td className="containertd">
                                  <div className="question question-weight">
                                    <span>S9.</span>
                                    <span className="quest-text-pad">
                                      Was the patient ever enrolled in a clinical
                                      trial for the treatment of MMA{" "}
                                      <u>prior to the index date</u>{" "}(
                                      <span className="indigo-text">
                                        {ptDetails.index_dt || "index date"}
                                      </span>
                                      )?
                                    </span>
                                  </div>
                                </td>
                                <td className="containertd">
                                  <div className="">
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="tmt_mma_prior_indexDt_1"
                                          name="rbl_tmt_mma_prior_indexDt"
                                          value={1}
                                          checked={
                                            ptDetails.rbl_tmt_mma_prior_indexDt ===
                                            Values.value1
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          Yes
                                        </span>
                                      </label>
                                    </div>
                                    <div>
                                      <label>
                                        <input
                                          type="radio"
                                          id="tmt_mma_prior_indexDt_0"
                                          name="rbl_tmt_mma_prior_indexDt"
                                          value={0}
                                          checked={
                                            ptDetails.rbl_tmt_mma_prior_indexDt ===
                                            0
                                          }
                                          onChange={HandleFieldChange}
                                        />
                                        <span className="radio-text-padding">
                                          No
                                        </span>
                                      </label>
                                    </div>
                                  </div>
                                  <ErrorField
                                    show={
                                      softErrList.rbl_tmt_mma_prior_indexDt_term
                                    }
                                    message={EligibilityCriteria_Msgs.Ineligible}
                                  />
                                  <ErrorField
                                    show={
                                      hardErrList.rbl_tmt_mma_prior_indexDt_empty
                                    }
                                    message={CommonError_Msgs.Msg1}
                                  />
                                </td>
                              </tr>
                            )}
                          </table>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>

              <div className="survey-section-content-foot">
                <SaveAndNavigate paths={navigatePaths} Save={SavePage} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EligibilityCriteria;
